import {LitElement} from 'lit';
import {html} from 'lit/html.js';

import css from './tt-share-button.pcss';

import '@polymer/paper-icon-button'
import '@polymer/iron-icon'
import '@material/mwc-menu'
import '@material/mwc-list/mwc-list-item.js';

import {TTUtil} from "../../utils/tt-util";

export default class TTShareButton extends LitElement {
    static get properties() {
        return {
            url: {
                type: String
            }
        };
    }

    static get styles() {
        return [css];
    }

    render() {
        return html`
            <div style="position: relative">
                <paper-icon-button id="button" icon="share"
                                   @click=${() => {
                                       let menu = this.shadowRoot.getElementById(
                                           'menu');
                                       let button = this.shadowRoot.getElementById(
                                           'button');
                                       menu.anchor = button;
                                       menu.show();
                                   }}></paper-icon-button>
                <mwc-menu owerflow id="menu"
                          corner="BOTTOM_END"
                          menuCorner="END">
                    <mwc-list-item @click=${this._facebook}>
                        <iron-icon icon="brand:facebook"></iron-icon>
                    </mwc-list-item>
                    <mwc-list-item @click=${this._twitter}>
                        <iron-icon icon="brand:twitter"></iron-icon>
                    </mwc-list-item>
                    <mwc-list-item @click=${this._whatsapp}>
                        <iron-icon icon="brand2:whatsapp"></iron-icon>
                    </mwc-list-item>
                </mwc-menu>
            </div>
        `;
    }

    getURL() {
        return this.url
            ? this.url
            : window.location.href;
    }

    _facebook() {
        TTUtil.withAnalytics(() => {
            ga('send', {
                hitType: 'social',
                socialNetwork: 'Facebook',
                socialAction: 'share',
                socialTarget: this.getURL()
            });
        });
        window.open("https://www.facebook.com/sharer/sharer.php?u=" + this.getURL());
    }

    _twitter() {
        TTUtil.withAnalytics(() => {
            ga('send', {
                hitType: 'social',
                socialNetwork: 'Twitter',
                socialAction: 'share',
                socialTarget: this.getURL()
            });
        });
        window.open("https://twitter.com/intent/tweet?url=" + this.getURL());
    }

    _whatsapp() {
        TTUtil.withAnalytics(() => {
            ga('send', {
                hitType: 'social',
                socialNetwork: 'WhatsApp',
                socialAction: 'share',
                socialTarget: this.getURL()
            });
        });
        window.open("whatsapp://send?text=" + encodeURI("Tischtennis Liveticker: "
            + this.getURL()));
    }

}

window.customElements.define('tt-share-button', TTShareButton);
